module.exports = __webpack_public_path__ + "static/img/Matt-Rowell.10cfb2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matt-Rowell.jpg
// module id = fWFZ
// module chunks = 0